import { Module, ActionContext } from 'vuex'
import { RootState, DefaultEmailService } from './state_models'
import { Location, MailGunAccount, SMTPService } from '../models';
import config from '../config';
import cloneDeep from 'lodash-es/cloneDeep';

export const defaultEmailService: Module<DefaultEmailService, RootState> = {
  namespaced: true,
  state: { defaultEmailService: {}, usingTheirOwnEmailService: false },
  getters: {
    usingTheirOwnEmailService: (state: DefaultEmailService, getters: any, rootState: RootState, rootGetters: any) => {
      return state.usingTheirOwnEmailService
    }
  },
  mutations: {
    set: (
      state: DefaultEmailService,
      payload: any
    ) => {
      state.defaultEmailService = payload
    },
    clearAll(state: DefaultEmailService) {
      state.defaultEmailService = {}
      state.usingTheirOwnEmailService = false
    },
    setUsingTheirOwnEmailService(state: DefaultEmailService, payload: any) {
      state.usingTheirOwnEmailService = payload
    }
  },
  actions: {
    checkFromVisibility: (context: ActionContext<DefaultEmailService, RootState>, serviceId: string): Promise<Boolean> => {
      return new Promise(async (resolve, reject) => {
        let service;
        if (context.state.defaultEmailService && context.state.defaultEmailService.id === serviceId) {
          service = context.state.defaultEmailService;
        } else {
          let obj = await SMTPService.getById(serviceId);
          service = { ...obj.data, id: obj.id };
        }
        if (service) {
          context.commit('set', service)
          if ((['gmail', 'yahoo mail', 'outlook'].indexOf(service.provider_type) !== -1 || (service.email && service.email.includes('@hotmail.com')))) return resolve(true)
        }
        return resolve(false)
      })
    },
    usingTheirOwnEmailService: async (context: ActionContext<DefaultEmailService, RootState>, locationId: string) => {

      if(config.mode === 'production') {
        const internalLocations = ['xrOhuU89oruw4k8XTH86', 'FT4vuuNRcBvK2sTsTEfL']
        const isInternalLocations =  internalLocations.indexOf(locationId) !== -1
        context.commit('setUsingTheirOwnEmailService', !isInternalLocations)
        return context.state.usingTheirOwnEmailService
      }

      let location: Location
      let locationFromStore:  {[key: string]: any};

      locationFromStore = cloneDeep(context.rootGetters['locations/getById'](locationId))

      if(locationFromStore) {
        location = new Location(locationFromStore)
      } else {
        location = await Location.getById(locationId)
      }

      const locationMailGunAccount = await MailGunAccount.getByLocationId(locationId)
      if(locationMailGunAccount) {
        context.commit('setUsingTheirOwnEmailService', true)
        return context.state.usingTheirOwnEmailService
      }

      const locationSmtpService = await SMTPService.getByLocationId(locationId)
      if(locationSmtpService && locationSmtpService.length) {
        context.commit('setUsingTheirOwnEmailService', true)
        return context.state.usingTheirOwnEmailService
      }

      const companyMailGunAccount = await MailGunAccount.getByCompanyId(location.companyId)
      if(companyMailGunAccount) {
        context.commit('setUsingTheirOwnEmailService', true)
        return context.state.usingTheirOwnEmailService
      }

      context.commit('setUsingTheirOwnEmailService', false)
      return context.state.usingTheirOwnEmailService

    },
    set: (context: ActionContext<DefaultEmailService, RootState>, payload) => {
      let service = { ...payload.data, id: payload.id }
      context.commit('set', service)
    },
    logout: {
      root: true,
      handler: (context: ActionContext<DefaultEmailService, RootState>) => {
        context.commit('clearAll')
      }
    }
  }
}
